// notes
export const FETCH_ALL_SECURE_NOTES_RECEIVED =
  "FETCH_ALL_SECURE_NOTES_RECEIVED";
export const FETCH_ALL_SECURE_NOTES_FAILURE = "FETCH_ALL_SECURE_NOTES_FAILURE";
export const FETCH_CURRENT_NOTE_RECEIVED = "FETCH_CURRENT_NOTE_RECEIVED";
export const FETCH_CURRENT_NOTE_FAILURE = "FETCH_CURRENT_NOTE_FAILURE";
export const SET_SCREEN_TO_NEW_NOTE = "SET_SCREEN_TO_NEW_NOTE";
export const SET_SCREEN_TO_SHOW_NOTE = "SET_SCREEN_TO_SHOW_NOTE";
export const SET_SCREEN_TO_NOTES_LIST = "SET_SCREEN_TO_NOTES_LIST";
export const SECURE_NOTES_DISABLED = "SECURE_NOTES_DISABLED";
export const CLEAR_NOTES_ERROR = "CLEAR_NOTES_ERROR";

// grants
export const FETCH_CURRENT_NOTE_GRANTS = "FETCH_CURRENT_NOTE_GRANTS";
export const RESET_GRANTS = "RESET_GRANTS";

// profile
export const FETCH_USER_RECEIVED = "FETCH_USER_RECEIVED";
export const FETCH_USER_FAILURE = "FETCH_USER_FAILURE";

// notification
export const PUSH_NOTIFICATION_TO_QUEUE = "PUSH_NOTIFICATION_TO_QUEUE";
export const REMOVE_NOTIFICATION_FROM_QUEUE = "REMOVE_NOTIFICATION_FROM_QUEUE";

// other
export const FETCH_BRANDING_RECEIVED = "FETCH_BRANDING_RECEIVED";
export const FETCH_BRANDING_FAILURE = "FETCH_BRANDING_FAILURE";
export const PROCEED_UNSUPPORTED_BROWSER = "PROCEED_UNSUPPORTED_BROWSER";
